<div id="canton" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg" fxLayout="row" fxLayoutAlign="space-between center">

      <!-- APP TITLE -->
      <div fxLayout="row" fxLayoutAlign="start center">

        <button class="mr-0 mr-sm-16" mat-icon-button [routerLink]="'/pages/users'">
          <mat-icon>arrow_back</mat-icon>
        </button>

        <div class="product-image mr-8 mr-sm-16" *fuseIfOnDom>
          <img [src]="'assets/images/user.svg'">
        </div>
        <div fxLayout="column" fxLayoutAlign="start start"
          *fuseIfOnDom>
          <div class="h2">
            {{'user.newUser' | translate}}
          </div>
          <div class="subtitle secondary-text">
            <span>{{'user.new_user_detail' | translate}}</span>
          </div>
        </div>
      </div>
      <!-- / APP TITLE -->

      <button mat-raised-button
        class="save-product-button mat-white-bg mt-16 mt-sm-0"
        [disabled]="formGroup && formGroup.invalid" (click)="addUser(true)">
        <span>{{'main.add' | translate}}</span>
      </button>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg">

      <!-- CONTENT -->
      <div class="content">
        <div class="content-block">

          <cropper [avatar]="''" [page]="'user'" (sendImg)="setImg($event)"></cropper>

        </div>
        <div class="content-block">
          <div>
            <form [formGroup]="formGroup">
              <mat-form-field class="width-50" >
                <mat-label>{{ 'user.firstName' | translate }}</mat-label>
                <input formControlName="firstName" matInput required>
              </mat-form-field>
              <mat-form-field class="width-50" >
                <mat-label>{{ 'user.lastName' | translate }}</mat-label>
                <input formControlName="lastName" matInput required>
              </mat-form-field>
              <mat-form-field appearance="fill" class="width-100">
                <mat-label>{{ 'user.role' | translate }}</mat-label>
                <mat-select formControlName="roleId" required>
                  @for (role of roles; track role.id) {
                    <mat-option [value]="role.id">
                      {{role.name}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="fill" class="width-100">
                <mat-label>{{ 'user.function' | translate }}</mat-label>
                <mat-select formControlName="functionTypeId">
                  @for (func of functions; track func.id) {
                    <mat-option [value]="func.id">
                      {{func.name}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field class="width-100" >
                <mat-label>{{ 'user.email' | translate }}</mat-label>
                <input formControlName="email" matInput required>
                @if (formGroup.get('email')?.hasError('checkEmailOnServer')) {
                  <mat-error>
                    {{'checkEmailOnServer' | translate}}
                  </mat-error>
                }
              </mat-form-field>
              @if (formGroup.get('countryId')?.enabled) {
                <mat-form-field appearance="fill" class="width-50">
                  <mat-label>{{ 'user.country' | translate }}</mat-label>
                  <mat-select formControlName="countryId">
                    @for (country of countries; track country.id) {
                      <mat-option [value]="country.id">
                        {{country.name}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (formGroup.get('cityId')?.enabled) {
                <mat-form-field appearance="fill" class="width-50">
                  <mat-label>{{ 'user.canton' | translate }}</mat-label>
                  <mat-select formControlName="cityId">
                    @for (city of cities; track city.id) {
                      <mat-option [value]="city.id">
                        {{city.name}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (formGroup.get('organizationId')?.enabled) {
                <mat-form-field appearance="fill" class="width-100">
                  <mat-label>{{ 'user.organization' | translate }}</mat-label>
                  <mat-select formControlName="organizationId">
                    @for (org of organizations; track org.id) {
                      <mat-option [value]="org.id">
                        {{org.name}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              <mat-form-field class="width-50" >
                <mat-label>{{ 'user.eCall' | translate }}</mat-label>
                <input formControlName="eCall" matInput>
              </mat-form-field>
              <mat-form-field class="width-50" >
                <mat-label>{{ 'user.phone' | translate }}</mat-label>
                <input formControlName="phone" matInput appPhoneMask>
              </mat-form-field>
              <mat-form-field appearance="fill" class="width-50">
                <mat-label>{{'Language' | translate}}</mat-label>
                <mat-select formControlName="lang" required>
                  @for (lang of languages; track lang) {
                    <mat-option [value]="lang.value">
                      {{lang?.label | translate}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </form>

          </div>
          <div>

          </div>
        </div>

      </div>
      <!-- / CONTENT -->

    </div>
    <!-- / CONTENT CARD -->

  </div>
  <!-- / CENTER -->
</div>

